module.exports = __webpack_public_path__ + "img/RedMissile-B02-2-250.9051b36f.jpg";